<div class="p-3 d-flex flex-column gap-1 bg-white m-2 rounded-3" [ngStyle]="{'height': scrHeight}">

    <!-- Header -->
    <div class="d-flex flex-column flex-lg-row justify-content-between pb-2 gap-3 gap-lg-0">
        <div class="d-flex flex-column gap-2 ps-1">
            <label class="mb-0">Review & Confirm Submission</label>
            <span style="color: #6b7280 ;font-size: 12px;">Please review all details before submitting your compliance
                evidence</span>
        </div>
        <div class="d-flex align-items-center gap-2 px-2 rounded-2"
            style="background-color: #EEF5FF; color: #0D6EFD; font-size: 12px; height: 35px;"><mat-icon
                style="font-size:18px;color: #0d6efd;display: flex;align-items: center;">info</mat-icon>
            Please review all sections and make modifications if necessary
        </div>
    </div>

    <!-- <div class="panel"> -->
    <div [ngStyle]="{'height': bodyHeight}" class="d-flex" style="overflow-y: auto;">

        <div class="d-flex flex-column flex-lg-row gap-3 flex-fill">

            <!-- LEFT PANEL -->
            <div class="d-flex flex-column gap-3" style="width: 100%;">
                <mat-accordion multi class="d-flex flex-column gap-3 w-100">

                     <!-- Project Information -->
                    <mat-expansion-panel expanded class="border rounded-3">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="d-flex align-items-center gap-4">
                                <span style="display: flex;"><mat-icon class="text-danger"
                                        style="font-size: 20px; width: 24px; height: 20px;">work_outline</mat-icon></span>
                                <span>Project Information</span>
                            </mat-panel-title>
                            <mat-panel-description>
                                <span class="text-danger p-0 edit-btn-hover"
                                    (click)="editProject(); $event.stopPropagation()">
                                    <span
                                        class="d-flex align-items-center justify-content-center rounded-circle edit-icon-wrapper"
                                        style="width: 32px; height: 32px; background-color: #fee2e2; border: 2px solid transparent; transition: all 0.1s ease;">
                                        <mat-icon class="edit-icon"
                                            style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; transition: all 0.1s ease;">edit</mat-icon>
                                    </span>
                                </span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div class="p-0">
                            <div class="mb-3">
                                <label class="d-flex text-uppercase mb-2"
                                    style="font-size: 11px; color: #6b7280; letter-spacing: 0.9px;">PROJECT NAME</label>
                                <div class="d-flex align-items-center gap-2 bg-light p-2 rounded-2 flex-wrap mb-2"
                                    style="font-size: 14px; color: #111827; min-height: fit-content; overflow-wrap: anywhere;">
                                    <span>{{projectData.projectName}}</span>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label class="d-flex text-uppercase mb-2"
                                    style="font-size: 11px; color: #6b7280; letter-spacing: 0.9px;">CONTACT
                                    PERSON</label>
                                <div class="d-flex align-items-center gap-2 bg-light p-2 rounded-2 flex-wrap mb-2"
                                    style="font-size: 14px; color: #111827; min-height: fit-content; overflow-wrap: anywhere;">
                                    <span>{{projectData.contactPerson}}</span>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label class="d-flex text-uppercase mb-2"
                                    style="font-size: 11px; color: #6b7280; letter-spacing: 0.9px;">DUE DATE</label>
                                <div class="d-flex align-items-center gap-2 bg-light p-2 rounded-2 flex-wrap mb-2"
                                    style="font-size: 14px; color: #111827; min-height: fit-content; overflow-wrap: anywhere;">
                                    <span>{{formatDueDate(projectData.dueDate)}}</span>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label class="d-flex text-uppercase mb-2"
                                    style="font-size: 11px; color: #6b7280; letter-spacing: 0.9px;">INSTRUCTION
                                    TYPE</label>
                                <div class="d-flex align-items-center gap-2 bg-light p-2 rounded-2 flex-wrap mb-2"
                                    style="font-size: 14px; color: #111827; min-height: fit-content; overflow-wrap: anywhere;">
                                    <span>{{projectData.instructionType}}</span>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label class="d-flex text-uppercase mb-2"
                                    style="font-size: 11px; color: #6b7280; letter-spacing: 0.9px;">DOCUMENT</label>
                                <div class="d-flex align-items-center gap-2 bg-light p-2 rounded-2 flex-wrap mb-2"
                                    style="font-size: 14px; color: #111827; min-height: fit-content; overflow-wrap: anywhere;">
                                    <span>{{projectData.documentNumber}}</span>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>

                    <!-- Collection Information -->
                    <mat-expansion-panel class="border rounded-3">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="d-flex align-items-center gap-4">
                                <span style="display: flex;"><mat-icon class="text-danger" style="font-size: 20px; width: 24px; height: 20px;">folder_open</mat-icon></span>
                                <span>Collection Information</span>
                            </mat-panel-title>
                            <mat-panel-description>
                                <span class="text-danger p-0 edit-btn-hover"
                                    (click)="editCollection(); $event.stopPropagation()">
                                    <span
                                        class="d-flex align-items-center justify-content-center rounded-circle edit-icon-wrapper"
                                        style="width: 32px; height: 32px; background-color: #fee2e2; border: 2px solid transparent; transition: all 0.1s ease;">
                                        <mat-icon class="edit-icon"
                                            style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; transition: all 0.1s ease;">edit</mat-icon>
                                    </span>
                                </span>

                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div class="p-0 d-flex flex-column flex-lg-row gap-3 justify-content-between">
                            <div class="mb-3" style="width: 100%;">
                                <label class="d-flex text-uppercase mb-2"
                                    style="font-size: 11px; color: #6b7280; letter-spacing: 0.9px;">SELECTED
                                    COLLECTIONS</label>
                                <div class="d-flex align-items-center gap-2 bg-light p-2 rounded-2 flex-wrap mb-2"
                                    style="font-size: 14px; color: #111827; min-height: fit-content; overflow-wrap: anywhere;">
                                    <mat-icon
                                        style="color: #10b981; font-size: 18px; width: 18px; height: 18px;">check</mat-icon>
                                    <span>{{collectionData.collection_name}}</span>
                                </div>
                            </div>
                            <div class="mb-3" *ngIf="subcollectionData && subcollectionData.length > 0"
                                style="width: 100%;">
                                <label class="d-flex text-uppercase mb-2"
                                    style="font-size: 11px; color: #6b7280; letter-spacing: 0.9px;">SUB-COLLECTIONS</label>
                                <div class="d-flex align-items-center gap-2 bg-light p-2 rounded-2 flex-wrap mb-2"
                                    *ngFor="let sub of subcollectionData"
                                    style="font-size: 14px; color: #111827; min-height: fit-content; overflow-wrap: anywhere;">
                                    <mat-icon
                                        style="color: #10b981; font-size: 18px; width: 18px; height: 18px;">check</mat-icon>
                                    <span>{{sub.sub_collection_name}}</span>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>

                    <!-- Departments & Team Members -->
                    <mat-expansion-panel class="border rounded-3">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="d-flex align-items-center gap-4">
                                <span style="display: flex;"><mat-icon class="text-danger"
                                        style="font-size: 20px; width: 24px; height: 20px;">domain</mat-icon></span>
                                <span>Departments & Team Members</span>
                            </mat-panel-title>
                            <mat-panel-description>
                                <span class="text-danger p-0 edit-btn-hover"
                                    (click)="editTeam(); $event.stopPropagation()">
                                    <span
                                        class="d-flex align-items-center justify-content-center rounded-circle edit-icon-wrapper"
                                        style="width: 32px; height: 32px; background-color: #fee2e2; border: 2px solid transparent; transition: all 0.1s ease;">
                                        <mat-icon class="edit-icon"
                                            style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; transition: all 0.1s ease;">edit</mat-icon>
                                    </span>
                                </span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div class="d-flex flex-column gap-3 p-0 py-3">
                            <div *ngFor="let dept of departmentData?.selectedDepartments"
                                class="border rounded-2 bg-white">
                                <div>
                                    <label class="d-flex text-uppercase mb-0 p-3 border-bottom bg-light"
                                        style="font-size: 14px;">{{dept.name}}</label>
                                    <div class="d-flex flex-column gap-3 py-2 px-3 border-bottom">
                                        <div *ngFor="let member of getTeamMembersByDepartment(dept.id)"
                                            class="d-flex align-items-center gap-2 p-2 rounded-2"
                                            style="background-color: #f9fafb;">
                                            <mat-icon
                                                style="font-size: 20px; width: 20px; height: 20px; color: #6b7280;">person</mat-icon>
                                            <div class="d-flex flex-column">
                                                <span style="font-weight: 500; font-size: 14px;">{{member.name}}</span>
                                                <span style="font-size: 12px; color: #6b7280;">{{member.email}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>

                </mat-accordion>
            </div>

            <!-- RIGHT PANEL -->
            <div class="d-flex flex-column" style="width: 100%;">
                <mat-accordion multi class="d-flex flex-column gap-3 w-100">

                    <mat-expansion-panel expanded class="border rounded-3">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="d-flex align-items-center gap-4">
                                <span style="display: flex;"><mat-icon class="text-danger"
                                        style="font-size: 20px; width: 24px; height: 20px;">mail_outline</mat-icon></span>
                                <span>Email Details</span>
                            </mat-panel-title>
                            <mat-panel-description>
                                <span class="text-danger p-0 edit-btn-hover"
                                    (click)="editEmail(); $event.stopPropagation()">
                                    <span
                                        class="d-flex align-items-center justify-content-center rounded-circle edit-icon-wrapper"
                                        style="width: 32px; height: 32px; background-color: #fee2e2; border: 2px solid transparent; transition: all 0.1s ease;">
                                        <mat-icon class="edit-icon"
                                            style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; transition: all 0.1s ease;">edit</mat-icon>
                                    </span>
                                </span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div class="p-0">
                            <div class="mb-3">
                                <label class="d-flex text-uppercase mb-2"
                                    style="font-size: 11px; color: #6b7280; letter-spacing: 0.9px;">TO:</label>
                                <div class="d-flex align-items-center gap-2 bg-light p-2 rounded-2 flex-wrap mb-2"
                                    style="font-size: 14px; color: #111827; min-height: fit-content; overflow-wrap: anywhere;">
                                    <span>{{emailData.toAddress}}</span>
                                </div>
                            </div>
                            <div class="mb-3" *ngIf="emailData.ccAddress && emailData.ccAddress.length > 0">
                                <label class="d-flex text-uppercase mb-2"
                                    style="font-size: 11px; color: #6b7280; letter-spacing: 0.9px;">CC:</label>
                                <div class="d-flex align-items-center gap-2 bg-light p-2 rounded-2 flex-wrap mb-2"
                                    style="font-size: 14px; color: #111827; min-height: fit-content; overflow-wrap: anywhere;">
                                    <span>{{emailData.ccAddress}}</span>
                                </div>
                            </div>
                            <div class="mb-3" *ngIf="emailData.bccAddress && emailData.bccAddress.length > 0">
                                <label class="d-flex text-uppercase mb-2"
                                    style="font-size: 11px; color: #6b7280; letter-spacing: 0.9px;">BCC:</label>
                                <div class="d-flex align-items-center gap-2 bg-light p-2 rounded-2 flex-wrap mb-2"
                                    style="font-size: 14px; color: #111827; min-height: fit-content; overflow-wrap: anywhere;">
                                    <span>{{emailData.bccAddress}}</span>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label class="d-flex text-uppercase mb-2"
                                    style="font-size: 11px; color: #6b7280; letter-spacing: 0.9px;">SUBJECT:</label>
                                <div class="d-flex align-items-center gap-2 bg-light p-2 rounded-2 flex-wrap mb-2"
                                    style="font-size: 14px; color: #111827; min-height: fit-content; overflow-wrap: anywhere;">
                                    <span>{{emailData.emailSubject}}</span>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label class="d-flex text-uppercase mb-2"
                                    style="font-size: 11px; color: #6b7280; letter-spacing: 0.9px;">BODY
                                    PREVIEW:</label>
                                <div class="d-flex align-items-center gap-2 bg-light p-2 rounded-2 flex-wrap mb-2 email-body-preview"
                                    style="font-size: 14px; color: #111827; min-height: fit-content; overflow-wrap: anywhere; white-space: pre-wrap; line-height: 1.6;">
                                    <div [innerHTML]="emailData.emailBody"></div>
                                </div>
                            </div>
                        </div>

                    </mat-expansion-panel>




                    <mat-expansion-panel class="border rounded-3">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="d-flex align-items-center gap-4">
                                <span style="display: flex;"><mat-icon class="text-danger rotation"
                                        style="font-size: 20px; width: 24px; height: 24px;">attachment</mat-icon></span>
                                <span class="d-flex align-items-center gap-2">
                                    Documents
                                    <span *ngIf="selectedFiles && selectedFiles.length > 0"
                                        class="d-flex align-items-center justify-content-center text-white rounded-circle"
                                        style="min-width: 8px; height: 19px; padding: 0 6px; background-color: #cc0000; font-size: 11px; font-weight: 600;">
                                        {{selectedFiles.length}}
                                    </span>
                                </span>
                            </mat-panel-title>
                            <mat-panel-description>
                                <span class="text-danger p-0 edit-btn-hover"
                                    (click)="editDocuments(); $event.stopPropagation()">
                                    <span
                                        class="d-flex align-items-center justify-content-center rounded-circle edit-icon-wrapper"
                                        style="width: 32px; height: 32px; background-color: #fee2e2; border: 2px solid transparent; transition: all 0.1s ease;">
                                        <mat-icon class="edit-icon"
                                            style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; transition: all 0.1s ease;">edit</mat-icon>
                                    </span>
                                </span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div class="d-flex flex-column my-3 p-0">
                            <div *ngIf="selectedFiles && selectedFiles.length > 0; else noFiles"
                                class="d-flex flex-column gap-3">
                                <div *ngFor="let file of selectedFiles"
                                    class="d-flex align-items-center gap-3 p-2 border rounded-2"
                                    style="background-color: #f9fafb;">
                                    <mat-icon
                                        style="font-size: 24px; width: 24px; height: 24px; color: #6b7280;">{{getFileIcon(file)}}</mat-icon>
                                    <div class="flex-fill d-flex flex-column gap-1">
                                        <span
                                            style="font-weight: 500; font-size: 14px; color: #111827;">{{file.file_name}}</span>
                                        <!-- <span style="font-size: 12px; color: #6b7280;">{{formatBytes(file.size)}}</span> -->
                                    </div>
                                    <span *ngIf="file.fromCollection" class="badge rounded-pill"
                                        style="font-size: 11px; padding: 2px 8px; background-color: #dbeafe; color: #1e40af; font-weight: 500;">Collection</span>
                                </div>
                            </div>
                            <ng-template #noFiles>
                                <div class="text-center p-4" style="color: #6b7280; font-size: 14px;">
                                    <mat-icon class="mb-2"
                                        style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db;">description</mat-icon>
                                    <p class="mb-0">No documents selected</p>
                                </div>
                            </ng-template>
                        </div>
                    </mat-expansion-panel>

                </mat-accordion>
            </div>
        </div>
    </div>

</div>